<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6" >
          <v-file-input
            v-model="item.file"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'AddIdLynxterForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        file: null,
    };
  },
  computed: {
    isLoading() {
      return (
         this.isLoading
       );
    },
    ...mapFields('profilefile', {
      isLoading : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.item.file.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.file);
      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
 
  },
  validations: {
    item: {
      file: {
        maxsizefile : maxsizefile(20),
      },
    }
  }
};
</script>
